import { type TeamMembershipSettings as ClientTeamMembershipSettings } from '@atlaskit/teams-client/types';
import { IdentityUserAri } from '@atlassian/ari';

import { TeamMembershipSettings } from '../types/team';

// Convert string literal membership settings to enum
export const getMembershipSettings = (
	setting: ClientTeamMembershipSettings,
): TeamMembershipSettings => {
	switch (setting) {
		case 'OPEN':
			return TeamMembershipSettings.OPEN;
		case 'MEMBER_INVITE':
			return TeamMembershipSettings.INVITE_ONLY;
		case 'ORG_ADMIN_MANAGED':
			return TeamMembershipSettings.ORG_ADMIN_MANAGED;
		default:
			return TeamMembershipSettings.INVITE_ONLY;
	}
};

export const parseUserAriToUserId = (ariId: string): string => {
	try {
		return IdentityUserAri.parse(ariId).userId;
	} catch {
		return ariId;
	}
};
